import { render, staticRenderFns } from "./MessageHelperModal.vue?vue&type=template&id=24ee2773&scoped=true"
import script from "./MessageHelperModal.vue?vue&type=script&lang=js"
export * from "./MessageHelperModal.vue?vue&type=script&lang=js"
import style0 from "./MessageHelperModal.vue?vue&type=style&index=0&id=24ee2773&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ee2773",
  null
  
)

export default component.exports